import script from "./Spinner.vue?vue&type=script&lang=ts&setup=true"
export * from "./Spinner.vue?vue&type=script&lang=ts&setup=true"

import "./Spinner.vue?vue&type=style&index=0&id=09abd2a2&scoped=true&lang=scss"

import exportComponent from "/var/icar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09abd2a2"]])

export default __exports__